import React, { useState, useEffect } from "react";
import "../../../../sass/galleryslider.scss";
import image1 from "../../../../asset/gallerycarousel/1.webp";
import image2 from "../../../../asset/gallerycarousel/2.webp";
import image3 from "../../../../asset/gallerycarousel/3.webp";
import image4 from "../../../../asset/gallerycarousel/4.webp";
import image5 from "../../../../asset/gallerycarousel/5.webp";
import image6 from "../../../../asset/gallerycarousel/6.webp";
import image7 from "../../../../asset/gallerycarousel/7.webp";
import image8 from "../../../../asset/gallerycarousel/8.webp";
import image9 from "../../../../asset/gallerycarousel/9.webp";
import image10 from "../../../../asset/gallerycarousel/10.webp";

export default function App() {
  const slides = [
    image1, image2, image3, image4, image5,
    image6, image7, image8, image9, image10
  ];

  const [visibleCount, setVisibleCount] = useState(4);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 600) {
        setVisibleCount(1);
      } else if (window.innerWidth < 900) {
        setVisibleCount(2);
      } else {
        setVisibleCount(4);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const maxSlideIndex = Math.max(0, slides.length - visibleCount);

  const prevSlide = () => {
    setCurrentSlide((prev) => Math.max(0, prev - 1));
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => Math.min(maxSlideIndex, prev + 1));
  };

  return (
    <div className="carousel">
      <button className="prev" onClick={prevSlide}>&#10094;</button>
      <button className="next" onClick={nextSlide}>&#10095;</button>
      <div
        className="carousel-inner"
        style={{
          width: `${(slides.length * 100) / visibleCount + 5}%`,
          transform: `translateX(-${(currentSlide * 100) / visibleCount}%)`
        }}
      >
        {slides.map((slide, index) => (
          <div key={index} className="slide">
            <img src={slide} alt={`Slide ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
}
